
export enum SocialSignInProvider{
    GOOGLE = 'google'
}